import GET_ARTICLES from "../plugins/getArticles";

const [w,d,l] = [window,document,window.location];

export default function LESSON() {
  const init = () => {

    // 各種レッスンバナー挿入
    const insertBanner = name => {
      $.get(`/asset/html/lesson-${name}-banner.html`).done(function(html){
        $('.p-lesson-trial').parent().after(html)
        console.info('%c%s%c is loaded','font-weight: bold',this.url,'');
      })
    }

    // レッスンヘッダー挿入
    const insertHeader = name => {
      $.get(`/asset/html/lesson-${name}-header.html`).done(function(html){
        $('.mainImgInner').after(html)
        $('#entry_contents','.ui-mobile').before(html)
        console.info('%c%s%c is loaded','font-weight: bold',this.url,'');
      })
    }
    
    switch(parseInt(w.query_string('article'))||1){
      case 1:
        insertHeader('point')
        insertBanner('science')
        d.documentElement.classList.add('is-custom-page')
        break
      case 5: insertHeader('5step'); break
      case 6:
        insertHeader('science')
        insertBanner('5step')
        d.documentElement.classList.add('is-custom-page')
        break
    }

  }

  $(() => {

    // レッスンナビゲーション挿入
    w.load['contentFooter'].done(() => {
      const nav = $(`
      <div class="p-lesson-nav${($.UA.is_mobile)?' is-sp':''}">
        <a href="/lesson/" class="p-lesson-nav__item">レッスンのポイント</a>
        <a href="/lesson/?mode=detail&amp;article=6" class="p-lesson-nav__item">科学的なレッスン</a>
        <a href="/lesson/?mode=detail&amp;article=5" class="p-lesson-nav__item">５ステップレッスン</a>
        <a href="/lesson/?mode=detail&amp;article=2" class="p-lesson-nav__item">メニューと料金</a>
        <a href="https://golflesson.resv.jp/" class="p-lesson-nav__item" target="_blank" rel="noopener noreferrer">レッスン予約</a>
        <a href="/lesson/?mode=detail&amp;article=4" class="p-lesson-nav__item">ゴルフスクールのご案内</a>
      </div>
      `)[0]
      $('.p-footer-contact,.moduletitle').after(nav)
      $('.p-lesson-nav').currentMenu({mode:0,default:999})
    })

    const scienceInit = () => {
      GET_ARTICLES('.p-science-voice [data-plugin="getArticles"]').done(() => {
        $('.p-science-voice__list').slick({
          autoplay: true,
          fade: false,
          speed: 200,
          pauseOnHover: false,
          pauseOnFocus: false,
          centerMode: true,
          arrows: false,
          infinite: true,
          variableWidth: true,
          swipeToSlide:true,
          slidesToShow: 4,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          }, {
            breakpoint: 768,
            settings: "unslick"
          }]
        })
      })
    }
    if( $('.p-science-voice__list').length ) scienceInit()
  })

  d.addEventListener('DOMContentLoaded',init)
}